import { ParametersEnum } from '../../../types';
import { colourFacetValues, doorTypeFacetValues, forWetRoomsFacetValues } from '../../../const';

export const getFacetsValues = (key: string, value: string | string[]): Array<string> => {
  switch (key) {
    case ParametersEnum.doorType:
      return (value as Array<keyof typeof doorTypeFacetValues>).map(type => doorTypeFacetValues[type]);
    case ParametersEnum.colour:
      return (value as Array<keyof typeof colourFacetValues>).map(color => colourFacetValues[color]);
    case ParametersEnum.forWetRooms:
      return [forWetRoomsFacetValues[value as keyof typeof forWetRoomsFacetValues]];
    default:
      return [''];
  }
};
